var render = function render(){var _vm=this,_c=_vm._self._c;return _c('standalone-layout',{attrs:{"top-classes":"mt-5"},scopedSlots:_vm._u([{key:"heading",fn:function(){return [_vm._v("Neues Passwort setzen")]},proxy:true},{key:"main",fn:function(){return [_c('NewPassword',{attrs:{"token":_vm.$route.query.t}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }